import * as backend from 'backend-helpers/memberPaymentHistory';

const GET_MEMBER_PAYMENT_HISTORY_REQUEST = 'GET_MEMBER_PAYMENT_HISTORY_REQUEST';
const GET_MEMBER_PAYMENT_HISTORY_SUCCESS = 'GET_MEMBER_PAYMENT_HISTORY_SUCCESS';
const GET_MEMBER_PAYMENT_HISTORY_FAILURE = 'GET_MEMBER_PAYMENT_HISTORY_FAILURE';

const initState = [];

export default function memberPaymentHistory(state = initState, action) {
    if (action.type == GET_MEMBER_PAYMENT_HISTORY_SUCCESS) {
        let {paymentHistory, ...rest} = action.result.data;

        return paymentHistory;
    }

    return state;
}

export function getMemberPaymentHistory() {
    return {
        types: [GET_MEMBER_PAYMENT_HISTORY_REQUEST, GET_MEMBER_PAYMENT_HISTORY_SUCCESS, GET_MEMBER_PAYMENT_HISTORY_FAILURE],
        promise: backend.getMemberPaymentHistory()
    }
}




// WEBPACK FOOTER //
// ./src/reducers/memberPaymentHistory.js